<template>
  <div id="authenticator">
    <div id="authcontainer" v-if="!loggedIn && !loading">
      <h2 v-if="!this.$store.state.auth">{{ formHeader }}</h2>
      <div class="unamecontainer">
        <label>Username</label>
        <input type="text" v-model="username" placeholder="Username">
      </div>
      <div class="emailcontainer" v-if="signup">
        <label>Email</label>
        <input type="email" v-model="email" placeholder="email@domain.com">
      </div>
      <div class="pwcontainer">
        <label>Password</label>
        <input type="password" v-model="currentPassword" placeholder="Password">
      </div>
      <div class="npwcontainer" v-if="changePass">
        <label>New Password</label>
        <input type="password" v-model="changedPassword" placeholder="New Password">
      </div>
      <div class="buttoncontainer">
        <button v-on:click="onLogin()" v-if="!loggedIn && !changePass && !signup">Login</button>
        <button v-on:click="onNewPassword()" v-if="changePass">Set New Password</button>
        <button v-on:click="onSignUp()" v-if="signup">Create Account</button>
      </div>
    </div>
    <div class="logoutcontainer" v-if="!loading && loggedIn">
      <h2>You are logged in.</h2>
      <button id="kitchenlink" v-on:click="$router.push(redirect)">{{ redirectTitle }}</button>
      <button id="logoutbutton" v-on:click="onLogout()">Logout</button>
    </div>
    <div class="linkscontainer">
      <router-link to="/login" v-if="signup">Login</router-link>
      <router-link to="/signup" v-if="!signup">Signup</router-link>
    </div>
    <div class="errorcontainer" v-if="errorMessage">
      <p>{{errorMessage}}</p>

    </div>
  </div>
</template>

<script>
import auth from '../mixins/auth'
import router from '../router'

export default {
  name: 'login',
  mixins: [auth],
  data() {
    return {
      loggedIn: false,
      loading: true,
      username: '',
      email: '',
      changePass: false,
      signup: false,
      currentPassword: '',
      changedPassword: '',
      errorMessage: '',
      formHeader: '',
      redirect: '/kitchen',
      redirectTitle: 'Kitchen'
    }
  },
  watch:{
    $route (){
      this.errorMessage = ''
      if (this.$route.name == 'login') {
        this.setHeader('LOGIN');
        this.signup = false
      } else {
        this.setHeader('SIGN UP');
        this.signup = true
      }
    }
  },
  beforeMount() {
    this.$store.commit('setHeaderClass', '');
    this.isAuthenticated(authenticated => {
      this.loading = false;
      console.log(authenticated)
      if (authenticated != 'not authenticated') {
        this.loggedIn = true;
      } else {
        this.loggedIn = false;
        if (this.$route.name == 'login') {
          this.setHeader('LOGIN');
        } else {
          this.setHeader('SIGN UP');
          this.signup = true
        }

      }
    });
    if (this.$route.query.redirect) {
      this.redirect = this.$route.query.redirect
      this.redirectTitle = this.redirect.substring(1)
    }
  },
  methods: {
    formIsValid() {
      if (this.username == null || this.currentPassword == null || (this.changePass && this.changedPassword == null)) {
        this.errorMessage = 'All fields are required';
        return false;
      } else {
        return true;
      }
    },
    setHeader(type) {
      switch(type) {
        case 'LOGIN':
          this.formHeader = 'Login';
          break;
        case 'NEW_PASS':
          this.formHeader = 'Password Rest Required';
          break;
        case 'SIGN UP':
          this.formHeader = 'Create an Account'
          break;
      }
    },
    onLogin() {
      this.errorMessage = null;
      this.login(this.username, this.currentPassword, (err, res) => this.handleAuthResult(err, res));
    },
    handleAuthResult(err, result) {
      switch (result) {
        case 'NEW_PASS':
          this.changePass = true;
          this.setHeader('NEW_PASS');
          break;
        case 'SUCCESS':
          this.loggedIn = true;
          break;
        case 'FAILURE':
          if (err) {
            if (err.message === 'User is not confirmed.') {
              this.errorMessage =  'Please verify your email.'
            }
            this.errorMessage = err.message;
          }
          break;
      }
    },
    onLogout() {
      window.HRS_LOGGEDOUT = true;
      this.loggedIn = false;
      this.username = null;
      this.currentPassword = null;
      this.setHeader('LOGIN');
      this.logout();
    },
    onNewPassword() {
      if (this.formIsValid()) {
        this.setNewPassAndLogin(this.username, this.currentPassword, this.changedPassword, (err, res) => {
          this.handleAuthResult(err, res);
        });
      }
    },
    onSignUp() {
      this.createAccount(this.username, this.email, this.currentPassword, (err, user) => {
        if (err) {
          console.log('Signup Error', err)
        } else {
          console.log('Signup success', user)
          router.push({ path: 'login' })
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
#authenticator {
  label {
    display: block;
    padding: 5px 0;
    margin-top: 15px;
  }
  input {
    font-size: 20px;
    padding:10px;
    width: calc(100% - 20px);
    border: 1px solid #eaeaea;
    background: transparent;
    color: #2c3e50;
    font-family: 'Nanum Gothic'
  }
  #authcontainer {
    border: 1px solid #eaeaea;
    padding: 20px;
    margin: 30px auto;
    max-width: 350px;

    .buttoncontainer {
      text-align: right;
    }

    button {
      cursor: pointer;
      color: #ffffff;
      background-color: #35495E;
      padding: 10px 50px;
      margin-top: 20px;
      border: none;
      font-size: 20px;
    }
  }
  .logoutcontainer {
    text-align: center;
    button {
      cursor: pointer;
      color: #ffffff;
      background-color: #35495E;
      padding: 10px;
      width: 200px;
      margin-top: 20px;
      border: none;
      font-size: 20px;
      display: block;
      margin: 20px auto;
      transition: all 0.3s ease;
      text-transform: capitalize;
      &:hover {
        color: #35495E;
        background-color: #eaeaea
      }
    }
  }
  .linkscontainer {
    text-align: center;
    a {
      padding: 10px;
      text-decoration: none;
      color: var(--lkred);
      transition: all 0.3s ease;
      margin: 5px;
      &:hover {
        background-color: var(--lkred);
        color: #ffffff;
      }
    }

  }
  .errorcontainer {
    max-width: 400px;
    text-align: center;
    margin: auto;
    font-size: 18px;
    color: var(--amazonOrange);
  }
  .confirmlink {
    color: var(--squidInk);
  }
}


</style>
